import { render, staticRenderFns } from "./TypeIntershipActivityEdit.vue?vue&type=template&id=5b33e9f2&"
import script from "./TypeIntershipActivityEdit.vue?vue&type=script&lang=js&"
export * from "./TypeIntershipActivityEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports